import { motion } from 'framer-motion';
import ChapterIndicator from './ChapterIndicator';
import { useI18n } from '@/contexts/I18nContext';
import ElfsightGoogleReviews from '@/components/ElfsightGoogleReviews';

const CinematicTestimonials = () => {
  const { t } = useI18n();

  return (
    <section className="relative py-8 md:py-12 bg-gradient-to-b from-amber-50 via-orange-50/50 to-amber-50 dark:from-cinema-dark dark:via-[#1a1815] dark:to-cinema-dark overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-amber-500/5 rounded-full blur-[120px]" />
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex justify-center">
          <ChapterIndicator act={t.testimonials.act} subtitle={t.testimonials.actSubtitle} light />
        </div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="text-center mb-6">
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white mb-1">
            {t.testimonials.title}
            <span className="text-amber-500 dark:text-amber-400"> {t.testimonials.titleAccent}</span>
          </h2>
          <p className="text-gray-500 dark:text-white/50 text-xs md:text-sm max-w-md mx-auto">
            {t.testimonials.subtitle}
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.3 }} className="relative">
          <div className="absolute -inset-2 border border-amber-500/10 rounded-2xl" />
          <div className="bg-white/80 dark:bg-[#1f1c17]/60 backdrop-blur-sm rounded-xl p-3 md:p-6 border border-amber-500/10">
            <ElfsightGoogleReviews />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CinematicTestimonials;
